<template>
    <el-dialog title="" :visible.sync="show" :modal="true" :close-on-click-modal="false" class="commonDialog deleteDialog" :append-to-body="true" ref="deleteDialog" @close="cancelDialog">
        <div slot="title">
            <i class="el-icon-warning"></i><span class="title">提示</span>
        </div>
        <div class="content">
            <div class="top">
                <h1>{{title}}</h1>
                <!-- <h2>{{content}}</h2> -->
            </div>
            <div class="footer">
                <el-button type="primary" class="confirm" @click="cancelDialog">返回首页</el-button>
                <template v-if="type">
                    <el-button type="cancel" class="cancel disable">提交发布</el-button>
                </template>
                <template v-else>
                    <el-button type="primary" class="confirm" @click="confirmDialog">提交发布</el-button>
                </template>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'deleteDialog',
    data() {
        return {
            show: false,
            title: '',
            content: '',
            type: false
        };
    },
    computed: {},
    components: {},
    watch: {},
    mounted() {},
    methods: {
        cancelDialog() {
            this.show = false;
            this.cancel.call(this);
        },
        confirmDialog() {
            this.confirm.call(this);

            this.show = false;
        },
    }
};
</script>
<style>
</style>